import GlobalBus from '@/plugins/GlobalBus';
import { GlobalBusNames } from '@/templates/DataNames';
import { createObserverHelper, ObserverParameters, unobserveHelper } from '@/heplers/index';
import { mobileDetect } from '@/heplers/detectMobile';

export class CodeExampleObservers {
  private static observerParams: ObserverParameters = {};
  private static createObserver = createObserverHelper;
  private static codeExampleObserverParams: ObserverParameters = {};
  private static unobserveObserver = unobserveHelper;

  public static bindObservers(fromScroll?: boolean) {
    CodeExampleObservers.initButtonCodeObserver(fromScroll);
    CodeExampleObservers.initCodeExampleObserver();
  }

  public static findViewportCodeExample(targetTop: number, selector: string): any {
    const codeExamples: NodeList = document.querySelectorAll(selector);
    let resultElement = null;
    let isFinded = false;

    // Элементы ищутся по порядку, поэтому ищем до 1 элемента
    codeExamples.forEach((element: any) => {
      if (isFinded) return;

      const diff = element.offsetTop - targetTop;

      if (diff < 400 && diff > -500) {
        resultElement = element;
        isFinded = true;
      }
    });

    return resultElement;
  }

  public static findAnchor(entry: any) {
    // проверяем на пустой id т.к. "Source Block" может не иметь title
    if (!entry.target.id || !entry.isIntersecting) return;

    CodeExampleObservers.setCurrentCodeButton(entry.target.id);
    GlobalBus.emit(GlobalBusNames.CHANGEEXAMPLE, entry.target.id);
  }

  public static setCurrentCodeButton(anchor: string) {
    if (!this.observerParams.selectors) return;

    this.observerParams.selectors.forEach((selector: HTMLElement) =>
      selector.classList.remove('is-current')
    );

    if (document.getElementById(anchor)) {
      document.getElementById(anchor).classList.add('is-current');
    }
  }

  public static runObserverResultFunctions(targetTop: number) {
    let resultElement = null;

    const targetElement = mobileDetect() ? '.docs-coderail' : '.button-code';

    resultElement = CodeExampleObservers.findViewportCodeExample(targetTop, targetElement);

    if (!resultElement) return;

    if (mobileDetect()) {
      GlobalBus.emit('setActiveCodeExample', resultElement.id);
    } else {
      CodeExampleObservers.setCurrentCodeButton(resultElement.id);
      GlobalBus.emit(GlobalBusNames.CHANGEEXAMPLE, resultElement.id);
    }
  }

  private static initButtonCodeObserver(fromScroll?: boolean) {
    this.observerParams = {
      selectors: document.querySelectorAll('.button-code'),
      options: {
        threshold: 0.05,
        rootMargin: '-10% 0px -50% 0px',
      },
      resultFunction: this.findAnchor,
      context: this,
    };

    if (!fromScroll)
      this.observerParams.selectors.forEach((selector: HTMLElement) => {
        selector.classList.remove('is-current');
      });

    this.unobserveObserver(this.observerParams);
    this.createObserver(this.observerParams);
  }

  private static initCodeExampleObserver() {
    this.codeExampleObserverParams = {
      ...this.observerParams,
      selectors: document.querySelectorAll('.docs-coderail'),
      resultFunction: (entry: any) => {
        GlobalBus.emit('setActiveCodeExample', entry.target.id);
      },
    };

    this.codeExampleObserverParams.selectors.forEach((codeExample: HTMLElement) => {
      codeExample.classList.remove('is-current');
    });

    this.unobserveObserver(this.codeExampleObserverParams);
    this.createObserver(this.codeExampleObserverParams);
  }
}
